export default "__VITE_ASSET__Dz4mQZN$__"